import { render, staticRenderFns } from "./quickConfigDialog.vue?vue&type=template&id=60a0ba22&"
import script from "./quickConfigDialog.vue?vue&type=script&lang=js&"
export * from "./quickConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports